/**
 * Nosto search watchdog.
 *
 * La recherche (drawer + page /search) est entierement rendue par le bundle des
 * templates Nosto, charge par l'app embed. Si ce bundle n'arrive pas ou plante a
 * l'initialisation, le theme ne s'en apercoit pas : l'input reste inerte et taper
 * ne declenche rien.
 *
 * Ce script controle que Nosto a bien pris la main, et reinjecte son script de
 * bootstrap si ce n'est pas le cas. Il ne recharge JAMAIS la page.
 */
!function () {
    const MAX_ATTEMPTS = 2;
    const RETRY_COOLDOWN = 4000;
    const RECHECK_DELAY = 4000;
    const FUNCTIONAL_DELAY = 2000;
    const SEARCH_PAGE_DELAY = 5000;

    let attempts = 0;
    let lastAttemptAt = 0;
    let givenUp = false;

    function input() {
        return document.querySelector(".nosto-search-input");
    }

    function dropdown() {
        return document.querySelector(".nosto-search-dropdown");
    }

    function results() {
        return document.querySelector(".nosto-search-results");
    }

    function isSearchPage() {
        return !!results() && document.body.classList.contains("template-search");
    }

    /**
     * Sur /search sans terme, Nosto n'a rien de significatif a rendre : le controle
     * fonctionnel n'y est pas fiable.
     */
    function hasQuery() {
        return !!new URLSearchParams(window.location.search).get("q");
    }

    /**
     * Le bundle Nosto s'est-il execute ?
     * Attention : window.nosto n'est PAS utilisable, il resout vers la window de
     * l'iframe injectee par Nosto et est donc toujours truthy.
     */
    function bundleLoaded() {
        return typeof window.nostojs === "function" && window.nostoTemplatesLoaded === true;
    }

    /**
     * Nosto a-t-il reellement rendu quelque chose ? Indispensable : le bundle peut
     * etre marque comme charge alors que son module a plante a l'evaluation.
     */
    function hasRendered() {
        if (isSearchPage()) {
            if (!hasQuery()) return true;
            return !!results() && results().children.length > 0;
        }
        return !!dropdown() && dropdown().children.length > 0;
    }

    function reinject() {
        const existing = document.querySelector('script[src*="market-init"]')
            || document.querySelector('script[src*="/script/shopify/"]');
        if (!existing) return false;

        const el = document.createElement("script");
        el.src = existing.src + (existing.src.indexOf("?") > -1 ? "&" : "?") + "nostoRetry=" + Date.now();
        el.async = true;
        document.head.appendChild(el);
        return true;
    }

    /**
     * Une fois Nosto revenu, on lui redonne l'evenement qu'il a rate pour que
     * l'autocomplete se rende sans que l'utilisateur ait a retaper.
     */
    function replayInput() {
        const el = input();
        if (el && el.value) {
            el.dispatchEvent(new Event("input", {bubbles: true}));
        }
    }

    function repair() {
        if (givenUp) return;

        if (attempts >= MAX_ATTEMPTS) {
            givenUp = true;
            console.warn("[gong] Nosto search indisponible apres " + attempts + " tentatives");
            return;
        }

        const now = Date.now();
        if (now - lastAttemptAt < RETRY_COOLDOWN) return;

        attempts++;
        lastAttemptAt = now;

        if (!reinject()) {
            givenUp = true;
            console.warn("[gong] Nosto search indisponible : script de bootstrap introuvable");
            return;
        }

        setTimeout(() => {
            if (!bundleLoaded()) {
                repair();
                return;
            }
            replayInput();
            setTimeout(() => {
                if (!hasRendered()) repair();
            }, FUNCTIONAL_DELAY);
        }, RECHECK_DELAY);
    }

    /**
     * @param {boolean} functional  verifier aussi que Nosto a rendu quelque chose,
     *                              et pas seulement que le bundle est charge.
     */
    function check(functional) {
        if (givenUp) return;
        if (!bundleLoaded()) return repair();
        if (functional && !hasRendered()) return repair();
    }

    function bind() {
        const el = input();

        if (el) {
            const onInteract = () => {
                check(false);
                // minQueryLength vaut 0 cote Nosto : le dropdown doit se remplir des
                // le focus, sans meme taper.
                setTimeout(() => check(true), FUNCTIONAL_DELAY);
            };
            el.addEventListener("focus", onInteract, {once: true});
            el.addEventListener("input", onInteract, {once: true});
        }

        const drawer = document.querySelector("w3-drawer-search.drawer-search");
        if (drawer) {
            drawer.addEventListener("drawer--open", () => check(false));
        }

        if (isSearchPage() && hasQuery()) {
            setTimeout(() => check(true), SEARCH_PAGE_DELAY);
        }
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", bind);
    } else {
        bind();
    }
}();
